import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';

import Display from '../../../util/Display';

class FieldMultiValue extends React.Component {

  delete = index => {
    const key = this.props.id;
    this.props.onValueChange(key, [ ...this.props.value ].filter((_, i) => i !== index));
  }

  add = () => {
    const key = this.props.id;
    const values = [ ...this.props.value, '' ];
    this.props.onValueChange(key, values);
  }

  handleChange = (index, value) => {
    const key = this.props.id;
    const values = [ ...this.props.value ];
    values[index] = value;
    this.props.onValueChange(key, values);
  }

  render() {
    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const values = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;
  
    return (
      <div className="col contactinfodiv">
        <Scroll.Element name={this.Key} />
        <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
        { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
        {
          values.map((value, i) =>
            <div key={`${key}_${i + 1}`} className="form-group">
              <div className="phone-code">  
                <FormControl
                  type="text"
                  value={value}
                  placeholder={field.label_name}
                  onChange={evt => this.handleChange(i, evt.target.value)}
                  className={`mr-sm-2 ${error ? 'error-w' : ''}`}
                  readOnly={!editable} />
              </div>
              { Display.MultiAction(i, this.add, this.delete) }
            </div>
          )
        }
      </div>
    );
  }
}
export default FieldMultiValue;